export const pluginID = 'customer-search-autofocus';
